export const checkSentimentOnPaste = {
  methods: {
    MX_postNlpOnPaste (copiedText, e) {
      let currentValOfCopied = copiedText;

      // Prevent textarea to call AWS Api for sentiment analysis
      // if (currentValOfCopied.length >= 500 || (e.target.value.length + currentValOfCopied.length) >= 500) {
      //   return
      // }

      if (e.target.value.length) {
        // If user first typed then pasted some text
        if ((e.target.value.length + currentValOfCopied.length) >= 500) {
          let howMuchToCut = 500 - e.target.value.length - 1;
          currentValOfCopied = currentValOfCopied.substring(0, howMuchToCut);
        }
      } else if (currentValOfCopied.length >= 500) {
        // If user pasted some text
        currentValOfCopied = currentValOfCopied.substring(0, 499);
      }

      let message = currentValOfCopied + ' ' + e.target.value;
      if (message.trim() !== '') {
        this.postNlpScore({
          text: message
        })
        .then(response => {
          this.nlp = response.data.data.sentiment.toLowerCase();
        })
        .catch(error => {
          if (error.response.status !== 406 && error.response.status !== 401 && error.response.status !== 402) {
            this.$snotify.error(this.$lang.messages.sn_genericError, 'ERROR');
          }
        })
      }
    }
  }
};
